import type { AppConfig } from '@/config/loadConfig';

export type AuthMode = 'msal' | 'stub';

/**
 * Resolves the effective auth mode (plan §2.1):
 * - explicit 'msal' always wins;
 * - 'stub' is honored ONLY in dev builds AND when environment === 'local' — the
 *   stub fabricates an authenticated user, and `environment` comes from the same
 *   mutable runtime config, so the build-time gate (import.meta.env.DEV is a
 *   compile-time constant) guarantees a production bundle can never resolve
 *   'stub' no matter what config.json claims (fail-closed posture);
 * - absent → 'stub' when dev build + environment === 'local' (local DX), else 'msal'.
 */
export function resolveAuthMode(config: Pick<AppConfig, 'authMode' | 'environment'>): AuthMode {
  if (config.authMode === 'msal') return 'msal';
  if (!import.meta.env.DEV) return 'msal';
  return config.environment === 'local' ? (config.authMode ?? 'stub') : 'msal';
}
